import React, { useState } from "react";
import { storeRequestCallback } from "../Adapter/PageAdapter";
import { toast } from "sonner";
import newArrImg from "../assets/images/arrw.svg";

const initialFormData = {
    patientName: "",
    contactNo: "",
    email: "",
    date: "",
    message: "",
};

// Book Appointment popup for a doctor card (same form & submit flow as the doctor listing page).
// doctor: { id, name, specialityId, specialityName }
const DoctorAppointmentModal = ({ doctor, onClose }) => {
    const [formData, setFormData] = useState(initialFormData);
    const [loading, setLoading] = useState(false);

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // Only allow numbers and plus in contactNo
        if (name === "contactNo") {
            const sanitizedValue = value.replace(/(?!^)\+/g, "").replace(/[^0-9+]/g, "");
            setFormData({ ...formData, [name]: sanitizedValue });
            return;
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleClose = () => {
        // Manually remove Bootstrap modal-related classes
        document.body.classList.remove("modal-open");

        // Remove the modal backdrop if it exists
        const modalBackdrops = document.getElementsByClassName("modal-backdrop");
        while (modalBackdrops.length > 0) {
            modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
        }

        onClose();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (loading) return;

        setLoading(true);

        const payload = {
            patient_name: formData.patientName,
            contact_number: formData.contactNo,
            email: formData.email,
            message: formData.message,
            appointment_date: formData.date,
            doctor_id: doctor.id,
            speciality_id: doctor.specialityId,
            doctor_name: doctor.name,
            speciality_name: String(doctor.specialityName || ""),
        };

        try {
            await storeRequestCallback(payload);
            toast.success("Request submitted successfully!");
            setFormData(initialFormData);
            handleClose();
        } catch (error) {
            console.error("Error submitting request:", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="modal fade custmodal-width custom-modalwdth2 show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modalclosebtn">
                        <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="intern-form-inner">
                            <h5>Request A Call Back Form:</h5>
                            <form onSubmit={handleSubmit}>
                                <div className="int-form-item">
                                    <label htmlFor="apptPatientName">
                                        Name of the Patient <span>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="apptPatientName"
                                        name="patientName"
                                        value={formData.patientName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="int-form-item">
                                    <label htmlFor="apptContactNo">
                                        Contact No <span>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="apptContactNo"
                                        name="contactNo"
                                        value={formData.contactNo}
                                        onChange={handleInputChange}
                                        pattern="^\+?[0-9]*$"
                                        maxLength={15}
                                        required
                                    />
                                </div>
                                <div className="int-form-item">
                                    <label htmlFor="apptEmail">Email</label>
                                    <input
                                        type="email"
                                        id="apptEmail"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="int-form-item">
                                    <label htmlFor="apptSpeciality">Speciality</label>
                                    <input
                                        type="text"
                                        id="apptSpeciality"
                                        value={doctor.specialityName || ""}
                                        readOnly
                                    />
                                </div>
                                <div className="int-form-item">
                                    <label htmlFor="apptDoctor">Doctor</label>
                                    <input
                                        type="text"
                                        id="apptDoctor"
                                        value={doctor.name || ""}
                                        readOnly
                                    />
                                </div>
                                <div className="int-form-item">
                                    <label htmlFor="apptDate">Please Select Date <span>*</span></label>
                                    <input
                                        type="date"
                                        id="apptDate"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleInputChange}
                                        min={new Date().toISOString().split("T")[0]}
                                        required
                                    />
                                </div>
                                <div className="int-form-item">
                                    <label htmlFor="apptMessage">Message</label>
                                    <textarea
                                        id="apptMessage"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        rows="5"
                                    ></textarea>
                                </div>
                                <div className="int-form-item">
                                    <button type="submit" disabled={loading}>
                                        {loading ? (
                                            <>
                                                <img src={newArrImg} alt="" className="spin" />
                                                Sending...
                                            </>
                                        ) : (
                                            <>
                                                <img src={newArrImg} alt="" />
                                                Submit
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DoctorAppointmentModal;
